export const routePathsHome = {
  HOME: '/',
  HEALTH: '/health',
  SUBSCRIPTIONS_OVERVIEW: '/admin/subscriptions-overview',
  SUPPORT: '/support',
  CONTACT: '/support/contact',
  RELEASE_NOTES: '/support/release-notes',
  API_DOCUMENTATION: '/support/api-documentation',
} as const;
